



















































































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import {readSubscriptionPackages, readSubscriptionPeriods, readSubscriptionsInfo} from '@/store/subscription/getters';
import {
  dispatchGetPackagePaymentUrl,
  dispatchGetSubscriptionPackages, dispatchGetSubscriptionPeriods,
  dispatchGetSubscriptionsInfo,
  dispatchToggleSubscriptionsAutoPay,
} from '@/store/subscription/actions';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import PackageCard from './PackageCard.vue';
import { commitSetSubscriptionPackages } from '@/store/subscription/mutations';

@Component({
  components: {
      PageSeparator,
      PackageCard,
  },
})
export default class Subscription extends Vue {
  public currentPeriod: any = null;
  public loadingUpdate: boolean = false;

  public async mounted() {
    commitSetSubscriptionPackages(this.$store, []);
    await dispatchGetSubscriptionPeriods(this.$store);
    if (this.periods[0]) {
      this.currentPeriod = this.periods[0].pk;
      await dispatchGetSubscriptionPackages(this.$store, { period: this.currentPeriod });
    }
    if (this.packages.length === 0) {
      this.$router.push('/dashboard');
      return null;
    }
    await dispatchGetSubscriptionsInfo(this.$store);
  }

  get periods() {
    return readSubscriptionPeriods(this.$store);
  }

  get packages() {
    return readSubscriptionPackages(this.$store);
  }

  get subscriptionsInfo() {
    return readSubscriptionsInfo(this.$store);
  }

  public async handleDisableSub(action) {
    this.loadingUpdate = true;
    await dispatchToggleSubscriptionsAutoPay(this.$store, {action});
    this.loadingUpdate = false;
  }

  public async handleChangePeriod() {
    await dispatchGetSubscriptionPackages(this.$store, { period: this.currentPeriod });
  }

  public async renewSubscription(id) {
    // TODO
    // const link = await dispatchGetPackagePaymentUrl(this.$store, {package: id});
    // if (link !== '') {
    //   const element = document.createElement('a');
    //   element.href = link;
    //   setTimeout(() => {
    //     element.click();
    //     }, 200);
    // }
  }

  get fieldsNames() {
    return [
      {
        key: 'package.title',
        // @ts-ignore
        label: this.$t('Package'),
        sortable: true,
      }, {
        key: 'start_date',
        // @ts-ignore
        label: this.$t('Date begin'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'end_date',
        // @ts-ignore
        label: this.$t('Date end'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'price',
        // @ts-ignore
        label: this.$t('Price'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];
  }
}
